import React from 'react';

const Bold = ({ 
  height = '48px', 
  width = '48px', 
  color = '#335262'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>bold</title>
    <g>
      <path d="M32.11566,23.14758v-0.1806c3.70642-1.21484,7.4129-4.4364,7.4129-10.2113 C39.52856,6.74072,36.61139,2,26.21942,2H6v4.86194l2.5473,0.72473C9.40698,7.83124,10,8.61658,10,9.51031v29.02252 c0,0.87323-0.56647,1.64551-1.39941,1.90771L6,41.25928V46h19.67261C35.21344,46,42,42.99396,42,34 C42,27.92316,39.04358,23.93939,32.11566,23.14758z M20,8h5c3.31372,0,6,2.68628,6,6s-2.68628,6-6,6h-5V8z M27,39h-7V27h7 c3.31372,0,6,2.68628,6,6S30.31372,39,27,39z" fill={color}/>
    </g>
  </svg>
);

export default Bold;
